<template>
  <div style="height: 600px;">
    <div style="height: 30px;width: 100%;background: #EFF3F3">
      <span style="font-size: 12px;margin-left: 20px;text-align: center;line-height: 30px;"
        >请输入要查询的车牌号</span
      >
    </div>
    <div class="checkCN">
      <div class="checkCN-inner">
        <em>车牌号:</em>
        <Input v-model="carNum" placeholder="请输入车牌号" style="width: 200px;margin-left: 5px" />
      </div>
      <div class="checkCN-inner">
        <em>车牌颜色:</em>
        <Select v-model="vco" style="width:200px;margin-left: 5px">
          <Option v-for="item in colorOptions" :value="item.value" :key="item.value">{{
            item.label
          }}</Option>
        </Select>
      </div>
      <div>
        <Button type="primary" style="margin-left: 10px;border-radius: 5px;" @click="commit(1)"
          >入网验证</Button
        >
        <Button type="primary" style="margin-left: 10px;border-radius: 5px;" @click="commit(2)"
          >入网确认</Button
        >
      </div>
    </div>

    <div style="height: 30px;width: 100%;background: #EFF3F3">
      <span style="font-size: 12px;margin-left: 20px;text-align: center;line-height: 30px;"
        >查询结果</span
      >
    </div>
    <div class="resultOne">{{ resultOne }}</div>
  </div>
</template>
<script>
import { apiGet } from "../../utils/api";
import moment from "moment";
import { hideLoading, showLoading } from "@/utils/util";

export default {
  name: "checkCN",
  data() {
    return {
      carNum: "",
      resultOne: "",
      vco: 2,
      colorOptions: [
        {
          label: "蓝色",
          value: 1,
        },
        {
          label: "黄色",
          value: 2,
        },
        {
          label: "黄绿色",
          value: 3,
        },
      ],
    };
  },
  methods: {
    commit(commitType) {
      let self = this;
      //提示填写信息
      if (this.carNum === "" || this.carNum == null) {
        this.$XModal.alert({
          message: "请填写车牌号！",
          status: "error",
        });
        return;
      }
      this.$XModal.confirm("请确认车牌号无误，确认后将付费查询").then((type) => {
        if (type === "confirm") {
          this.checkTruckExist(commitType);
        }
      });
    },
    async checkTruckExist(type) {
      // console.log("%ccheckCN.vue line:84 object", "color: #007acc;", type);
      let url = type === 2 ? "checkVehicleExistV2" : "checkTruckExist";
      // console.log("%ccheckCN.vue line:86 object", "color: #007acc;", url);
      let params = {
        method: url,
        params: {
          vno: this.carNum,
          vco: this.vco,
        },
      };
      showLoading();
      let res = await apiGet("api/order/track/", params.method, params.params);
      hideLoading();
      if (res.status === 1) {
        if (type === 1) {
          let data = JSON.parse(res.data);
          if (data == null || data.result == null) {
            this.resultOne = "入网状态：无结果";
          } else if (data.result.length === 13) {
            this.resultOne =
              "入网状态：已入网" +
              "\n" +
              "最后定位时间：" +
              this.timestampToTime(parseInt(data.result));
          } else if (data.result === "no") {
            this.resultOne = "入网状态：未入网";
          } else if (data.status === 1006) {
            this.resultOne = "入网状态：无结果";
          } else {
            this.resultOne = data.result;
          }
        } else {
          let { data } = res;
          console.log('%ccheckCN.vue line:118 res', 'color: #007acc;', res);
          let result = JSON.parse(data).result;
          let txt = result === "no" ? "入网状态：未入网" : moment(+result).format("YYYY-MM-DD");
          this.$XModal.alert({
            message: txt,
          });
        }
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "-";
      let M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
      let D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
      let h = date.getHours() < 10 ? "0" + date.getHours() + ":" : date.getHours() + ":";
      let m = date.getMinutes() < 10 ? "0" + date.getMinutes() + ":" : date.getMinutes() + ":";
      let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
  },
};
</script>
<style scoped>
.checkCN {
  height: 40%;
  width: 100%;
  display: flex;
  /* align-items: center; */
  justify-content: center;
  margin-left: 80px;
  flex-direction: column;
}
.checkCN-inner {
  margin-bottom: 20px;
}
.checkCN-inner em {
  display: inline-block;
  width: 60px;
}

.resultOne {
  height: 20%;
  width: 100%;
  display: flex;
  align-items: center;
  margin-left: 80px;
  white-space: pre;
}
</style>
